export const colors = {
  primary: '#007bff',
  secondary: '#6c757d',

  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',

  light: '#f8f9fa',

  white: '#fff',
  black: '#000',

  borderGrey: '#ebedf2',
  borderGreyDark: '#ebecee',
}

export const backgrounds = {
  bgGreyLight: '#fdfdfd',
  bgHeaderLight: '#f7f9fb',
}

export const themes = {
  blue: {
    color: '#fff',
    bgColor: '#00b3ff',
  },
  darkBlue: {
    color: '#fff',
    bgColor: 'hsl(253, 100%, 50%)',
  },
  lightBlue: {
    color: '#fff',
    bgColor: 'hsl(189, 100%, 50%)',
  },
  green: {
    color: '#2d4710',
    bgColor: '#86f250',
  },
  gray: {
    color: '#f7f9fb',
    bgColor: '#bbbcbc',
  },
  yellow: {
    color: 'hsl(40, 50%, 30%)',
    bgColor: '#ffd800',
  },
  purple: {
    color: 'hsl(235, 75%, 90%)',
    bgColor: '#473bbe',
  },
}
